import React from 'react';
import { createPortal } from 'react-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import TeaserPhoto from 'components/TeaserPhoto';
import { GoBack } from '../../../../../pages/Page';
import { IconButton } from 'components/Button';
import './index.sass';
import Model from '../../../../../../model';

const { block, el } = bem('short-mobile-fixed-specialist-teaser');

const ShortMobileFixedSpecialistTeaser = ({sticky, name, id, photo}) => {
    const { openSpecialistOrderForm } = Model.modal;
    const onClick = (e) => {
        e.preventDefault();
        openSpecialistOrderForm(id);
    }
    const shortTeaser = (
        <div className={block({'sticky': sticky})}>
            <div className={el('left-block')}>
                <div className={el('go-back')}>
                    <GoBack />
                </div>
                <div className={el('specialist')}>
                    <div className={el('photo')}>
                        <TeaserPhoto src={photo} />
                    </div>
                    <div className={el('name')}>
                        <Text serif>{name}</Text>
                    </div>
                </div>
            </div>
            <div className={el('button')}>
                <IconButton name={'calendar-check'} onClick={onClick} mod={'transparent-gold'}/>
            </div>
        </div>
    )
    return createPortal(shortTeaser, document.getElementById('short-fixed-specialist-teaser'));
}

export default ShortMobileFixedSpecialistTeaser;
